export default {
  id: "whatAmIMissingOutOn",
  name: "",
  description: "",
  report: {
    name: "What am I missing out on?",
    chartType: "",
    template: "what-am-i-missing-out-on",
    config: {
      dataType: "single",
      dataSet: "InventoryAnalysis",
      dimensions: [],
      measures: [],
      sort: {
        direction: null,
        by: null,
      },
      filters: [],
      compare: false,
      limit: "50",
      rowTotals: false,
      stacked: false,
      points: false,
      colorTheme: "default",
      applyDateRangeFilter: true,
      filterDateRange: true,
      applyGlobalFilter: true,
    },
  },
};
